import { render, staticRenderFns } from "./OrgItem.vue?vue&type=template&id=42482b66"
import script from "./OrgItem.vue?vue&type=script&lang=js"
export * from "./OrgItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports